// extracted by mini-css-extract-plugin
export var container = "pageSlider-module--container--ec717";
export var pageCtn = "pageSlider-module--pageCtn--375ab";
export var toggle = "pageSlider-module--toggle--5f320";